var lazyLoading = (function () {
  return {
    init: init,
    show: showImagesOnView
  };
  function init() {
    document.addEventListener('DOMContentLoaded', onReady);
  }
  
  function onReady() {
    // Show above-the-fold images first
    showImagesOnView();

    // scroll listener
    window.addEventListener('scroll', showImagesOnView, false);

    //checkbox click event
    var checkboxList = document.querySelectorAll("input[type=checkbox]");

    for (var i = 0; i < checkboxList.length; i++) {
      checkboxList[i].addEventListener( 'change', function() {
          if (this.checked) {
            showImagesOnView();
          }
      });
    }
  }

  // Show the image if reached on viewport
  function showImagesOnView() {
    var images = document.getElementsByClassName("b-lazy-hidden"),
      imagesBG = document.querySelectorAll("[data-lazy-style]"),
      mobileBgImg = document.querySelectorAll("[data-lazy-mob-bg]");

    //For Image Tag
    for (var i = 0; i < images.length; i++) {
      show(images[i]);
    }
    //For background images
    for (var i = 0; i < imagesBG.length; i++) {
      showLazyBG(imagesBG[i]);
    }
    //For mobile background images
    for (var i = 0; i < mobileBgImg.length; i++) {
      showLazyBG(mobileBgImg[i]);
    }
  }

  function showLazyBG(el) {
    // Compare the position of image and scroll
    var bounding = el.getBoundingClientRect(),
      isOnView = bounding.top >= 0
        && bounding.left >= 0
        && bounding.top <= (window.innerHeight || document.documentElement.clientHeight) * 2,
      isHidden = bounding.top == 0 && bounding.bottom == 0 && bounding.left == 0 && bounding.right == 0 && bounding.width == 0 && bounding.height == 0 && bounding.x == 0 && bounding.y == 0;

    if (isOnView && !isHidden) {
      //check if mobile bg image has been uploaded
      if (null !== el.getAttribute("data-lazy-mob-bg")) {
        el.setAttribute("data-lazy-mob-style", el.getAttribute("data-lazy-mob-bg"));
        el.removeAttribute("data-lazy-mob-bg");
      }

      //check if ratina
      if (null === el.getAttribute("style")) {
        if (window.innerWidth <= 640 && null !== el.getAttribute("data-lazy-mob-style")) {
          el.setAttribute("style", el.getAttribute("data-lazy-mob-style"));
          el.removeAttribute("data-lazy-mob-style");
        } else if (
          null !== el.getAttribute("data-lazy-ratina") &&
          window.devicePixelRatio > 1
        ) {
          el.setAttribute("style", el.getAttribute("data-lazy-ratina"));
          el.removeAttribute("data-lazy-ratina");
        } else if (null !== el.getAttribute("data-lazy-style")) {
          el.setAttribute("style", el.getAttribute("data-lazy-style"));
          el.removeAttribute("data-lazy-style");
        }
      }
    }
  }

  function show(el) {
    // Compare the position of image and scroll
    var bounding = el.getBoundingClientRect(),
      isOnView = bounding.top >= 0
        && bounding.left >= 0
        && bounding.top <= (window.innerHeight || document.documentElement.clientHeight) * 2,
      isHidden = bounding.top == 0 && bounding.bottom == 0 && bounding.left == 0 && bounding.right == 0 && bounding.width == 0 && bounding.height == 0 && bounding.x == 0 && bounding.y == 0;

    if (el.tagName === "IFRAME" && isOnView && !isHidden) {
      el.addEventListener("load", function () {
        if (!el.classList.contains("b-lazy-loaded")) {
          el.classList.add("b-lazy-loaded");
        }
        el.classList.remove("b-lazy-hidden");
      });

      if (null !== el.getAttribute("data-lazysrc")) {
        el.setAttribute("src", el.getAttribute("data-lazysrc"));
        el.removeAttribute("data-lazysrc");
      }
    } else if (isOnView && !isHidden) {
      var LazyAttr = ["srcset", "sizes", "src"];
      if (window.innerWidth <= 640) {
        LazyAttr = ["mob-srcset", "sizes", "src"]
      }
      el.addEventListener("load", function () {
        if (!el.classList.contains("b-lazy-loaded")) {
          el.classList.add("b-lazy-loaded");
        }
        el.classList.remove("b-lazy-hidden");
      });
      LazyAttr.forEach(function (value) {
        //if mob-srcset not found then set default srcset
        if (null === el.getAttribute("data-lazy-" + value) && value === "mob-srcset" ) {
          value = "srcset";
        }
        
        if (null !== el.getAttribute("data-lazy-" + value)) {
          el.setAttribute( (value.indexOf("mob-") >= 0 ? value.replace("mob-", "") : value ) , el.getAttribute("data-lazy-" + value));
          el.removeAttribute("data-lazy-" + value);
          if (value === "mob-srcset" && null !== el.getAttribute("data-lazy-srcset")) {
            el.removeAttribute("data-lazy-srcset");
          }
        }
      });
    }
  }
})();

lazyLoading.init();